import React from 'react';
import PropTypes from 'prop-types';

import { Icon } from 'components/common/Elements/Elements';

import { changeIconDivice } from 'utils/common.js';

import classes from './Os.module.scss';

const Os = ({ os, osVersion = '' }) => {
  return (
    <>
      <div className={classes.icon}>
        <Icon
          size="16px"
          icon={changeIconDivice(os, osVersion)}
          color="#3a5ba2"
        />
      </div>
      {os.toLowerCase() === 'linux'
        ? osVersion.toLowerCase().includes('ubuntu')
          ? 'Ubuntu'
          : 'Linux'
        : os}
    </>
  );
};

Os.propTypes = {
  os: PropTypes.string,
  osVersion: PropTypes.string
};

export default Os;
